@if (data && data.headerText) {
  <div class="survey-page-section" [class.mobile-view]="viewMode === 'mobile'"
    [style.background-color]="data.backgroundColor">
    <div class="survey-page-inner" [style.text-align]="data.headerAlignment"
      [class.mobile-view]="viewMode === 'mobile'">
      <h3
        [class.mobile-view]="viewMode === 'mobile'"
        class="survey-page-header m-0" [style.color]="data.headerColor"
        [style.font-size]="data.headerFontSize + 'px'" [style.font-family]="data.headerFontFamily"
        [style.font-weight]="data.headerFontWeight" [style.text-align]="data.headerAlignment">
        {{ data.headerText }}
      </h3>
      <p
        [class.mobile-view]="viewMode === 'mobile'"
        class="survey-page-description m-0" [style.color]="data.descriptionColor"
        [style.font-size]="data.descriptionFontSize + 'px'" [style.font-family]="data.descriptionFontFamily"
        [style.font-weight]="data.descriptionFontWeight">
        {{ data.descriptionText }}
      </p>
    </div>
  </div>
}
